// config.ts
const config = {
  development: {
    apiBaseUrl: 'http://localhost:3000/api',
    storageBaseUrl: 'http://localhost:3000/api/storage',
    authBaseUrl: 'http://localhost:3000/api/auth',
    databaseUrl: process.env.DATABASE_URL || 'postgresql://localhost:5432/palmgarden'
  },
  production: {
    apiBaseUrl: 'https://api.palmgardenrs.com/api',
    storageBaseUrl: 'https://api.palmgardenrs.com/api/storage',
    authBaseUrl: 'https://auth.palmgardenrs.com/api/auth',
    databaseUrl: process.env.DATABASE_URL
  }
};

const isProduction = window.location.hostname !== 'localhost' && 
                     window.location.hostname !== '127.0.0.1';

export default isProduction ? config.production : config.development;

